import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import getAPIbaseURL from "../../utils/helpers";

const API_URL = `${getAPIbaseURL()}/notifications`;

export const createNotification = createAsyncThunk(
  "notifications/create",
  async (data, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(`${API_URL}/`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || "Error creating notification");
    }
  }
);

export const fetchNotifications = createAsyncThunk(
  "notifications/fetch",
  async (params = {}, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const query = new URLSearchParams(params).toString();
      const response = await axios.get(`${API_URL}?${query}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || "Error fetching notifications");
    }
  }
);

export const updateNotification = createAsyncThunk(
  "notifications/update",
  async ({ id, update }, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(`${API_URL}/${id}`, update, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || "Error updating notification");
    }
  }
);

export const deleteNotification = createAsyncThunk(
  "notifications/delete",
  async (id, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${API_URL}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || "Error deleting notification");
    }
  }
);



const notificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    items: [],
    isLoading: false,
    error: null,
    message: null,
  },
  reducers: {
    receiveNotification: (state, action) => {
      const exists = state.items.find((n) => n.id === action.payload.id);
      if (!exists) {
        const newNotification = { ...action.payload, isNew: true };
        state.items.unshift(newNotification);
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createNotification.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createNotification.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items.push(action.payload);
        state.message = "Notification created";
      })
      .addCase(createNotification.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(fetchNotifications.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        // for now every notification is a new notification
        state.items = action.payload.map(n => ({
          ...n,
          isNew: n.isNew !== undefined ? n.isNew : true
        }));
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(updateNotification.fulfilled, (state, action) => {
        const index = state.items.findIndex((n) => n.id === action.payload.id);
        if (index !== -1) {
          state.items[index] = action.payload;
        }
        state.message = "Notification updated";
      })

      .addCase(deleteNotification.fulfilled, (state, action) => {
        state.items = state.items.filter((n) => n.id !== action.payload);
        state.message = "Notification deleted";
      });
  },
});

export const { receiveNotification } = notificationsSlice.actions;
export default notificationsSlice.reducer;
